import styled from "styled-components";
import { ImageStyled } from "../../../../../base/multimedia/image/styled.js";
import { FontMixin } from "../../../../../../styles/common/mixins/helpers.styled.js";
export const MasonryWrapper = styled.div.withConfig({
    displayName: "styled__MasonryWrapper",
    componentId: "sc-f21874e2-0"
})`
	${ImageStyled} {
		position: relative;
		width: 184px;
	}

	& figcaption {
		${FontMixin({
    size: 'medium',
    weight: 'medium',
    height: 'base'
})}
		background-color: ${({ theme  })=>theme.colors.white.base};
		bottom: 8px;
		color: ${({ theme  })=>theme.colors.grays.darker};
		left: 8px;
		padding: 8px 10px 10px;
		position: absolute;
		top: initial;
		transform: initial;
	}
`;

//# sourceMappingURL=styled.js.map